import Axios from "axios";
import {
  getFixelDataMock,
  getFixelFacebookAudiencesDataMock,
  getFixelFacebookDataMock
} from "../devData/getFixelDataMock";
import axios from "axios";
import Firebase from "./firebase";

export const wpUrl = getWpAjaxUrl();

const axiosShopWrapper = async (method, url, data) => {
  if (!["get", "post", "put", "delete"].includes(method))
    throw new Error("Unknown method");
  try {
    const res = await Axios[method](url, data);
    return res;
  } catch (e) {
    console.log('axiosShopWrapper',e.message||e);
  }
};
/**
 *
 * @param method
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
export const getFixelData = async (method, url, data) => {
  if (!["get", "post", "put", "delete"].includes(method))
    throw new Error("Unknown method");

  if(process.env.NODE_ENV !== 'production'){// mock a request
    return later(100,getFixelDataMock());
  }else {
    let form_data = formDataFromObj(data);
      return await Axios[method](url, form_data);
  }
}
/**
 *
 * @param fxl_code
 * @returns {Promise<unknown>}
 */
export const getFBAudiences = async (fxl_code) => {
  if(process.env.NODE_ENV !== 'production'){ // mock a request
    const result = await later(100,getFixelFacebookDataMock());
    result.data.data = JSON.parse(result.data.data);
    return result;
  }

  try {
    const payload = {
      action: 'fxl_get_facebook_data',
      fxl_code: fxl_code
    }

    const result = await formDataWithToken(
        wpUrl,
        payload
    );

    if(result?.data?.data && typeof result.data.data === 'string'){
      result.data.data = JSON.parse(result.data.data);
    }

    return result;

  }catch (error){
    console.error(
        "TCL ~ file: SelectFBAccount.js ~ getFbAccountData ~ error",
        error.message || error,
    );
  }
}

/**
 *
 * @returns {Promise<accounts>}
 */
export const getFBAccountsData = async () => {
  try {

    const payload = {
      action: 'fxl_get_facebook_account_data',
      fbId: sessionStorage.fbId,
      fbToken: sessionStorage.fbToken
    }

    if(process.env.NODE_ENV !== 'production'){// mock a request
      return later(100,getFixelFacebookDataMock());
    }

    return await formDataWithToken(
        wpUrl,
        payload
    );

  } catch (error) {
    console.error(
        "TCL ~ file: SelectFBAccount.js ~ getFbAccountData ~ error",
        error.message || error,
    );
  }
};

/**
 *
 * @param FBState
 * @param user
 * @param fullFixelData
 * @returns {Promise<unknown>}
 */
export const sendFBAccountToFixelApi = async (FBState,user,fullFixelData) => {

  if(process.env.NODE_ENV !== 'production'){
    return later(100,getFixelFacebookAudiencesDataMock());
  }

  try {
    const payload = {
      action: 'fxl_send_fb_account_to_fixel_api',
      account: FBState.fbAccountData[FBState.selectedAccountIndex].id,
      account_name: FBState.fbAccountData[FBState.selectedAccountIndex].name,
      pixel: FBState.fbAccountData[FBState.selectedAccountIndex].pixels[FBState.selectedPixelIndex].id,
      pixel_name: FBState.fbAccountData[FBState.selectedAccountIndex].pixels[FBState.selectedPixelIndex].name,
      displayName: getHostname(window.location.hostname),
      fbToken: sessionStorage.fbToken,
      email: user.email,
      fxl_code: fullFixelData.code
    }
    return await formDataWithToken(
        wpUrl,
        payload
    )
  } catch (error) {
    console.error(
        "TCL ~ file: SelectFBAccount.js ~ connectFBAccount ~ e",
        error.message || error,
    );
    if(error.response) {
      throw error;
    }
  }
};

/**
 *
 * @param data
 * @returns {FormData}
 */
export function formDataFromObj(data){
  const form_data = new FormData();
  for (let [key, value] of Object.entries(data)) {
    if(typeof value === 'object' && value !== null){
      value = JSON.stringify(value);
    }
    form_data.append(key, value);
  }
  return form_data;
}

/**
 *
 * @param data
 * @returns {Promise<void>}
 */
export async function withToken(data){
  const token = await Firebase.getUserToken();
  data.append('token',token);
}

/**
 * Create a form data request via axios
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const formDataWithToken = async (url, data) => {
    const form_data = formDataFromObj(data);
    await withToken(form_data);
    return axios.post(url, form_data);
}

/**
 *
 * @param user
 * @returns {Promise<boolean|AxiosResponse<any>|undefined>}
 */
export const verifyCustomer = async (user) => {
  if(process.env.NODE_ENV !== 'production'){
    return later((value) => {return value}, {data : { data : true, success: true }});
  }
  return formDataWithToken(wpUrl,{user: user.email, action: 'fxl_validate_customer'} );
}

/**
 *
 * @param email
 * @returns {Promise<AxiosResponse<any>|undefined>}
 */
export const doesHaveSegments = (email) => {
  if(process.env.NODE_ENV !== 'production'){
    return later((value)=>{return value}, {data : true});
  }
  return formDataWithToken(wpUrl,{email: email, action: 'fxl_check_segment',display: getHostname(window.location.hostname)} );
}

/**
 * Create segment in FixelAPI and add Fixel script to shop
 * @param user
 * @returns {Promise<AxiosResponse<any>|undefined>}
 */
export const creatCustomer = async (user) => {
  let createCustomerObj = {
    action: 'fxl_create_customer',
    customer: JSON.stringify({email: user.email, name: user.displayName}),
  }
  return formDataWithToken(wpUrl,createCustomerObj);
}

/**
 *
 * @param url
 * @returns {string}
 */
export const getHostname = (url) => {
  try {
    let u = window.location.hostname.split('.co')[0];
    u = u.includes('www.')? u.split('www.')[1]:u;
    return u;
  }catch (e) {
    return window.location.hostname;
  }
}

/**
 * A mock function for testing
 * @param delay
 * @param value
 * @returns {Promise<unknown>}
 */
function later(delay, value) {
  return new Promise(resolve => setTimeout(resolve, delay, value));
}

/**
 *
 * @returns {string|string|*}
 */
function getWpAjaxUrl() {
  if(window.ajaxurl){
    return window.ajaxurl;
  }
  if(process.env.wpUrl){
    return process.env.wpUrl;
  }else {
    return `${window.location.protocol}//${window.location.hostname}/wp-admin/`;
  }
}

export default axiosShopWrapper;
